/** Width of the left icon rail in pixels */
export const ICON_RAIL_WIDTH = 52;

/** Width of the slide-out detail panel in pixels */
export const PANEL_WIDTH = 340;

/** Spring animation config for panel slide transitions */
export const PANEL_SPRING = { type: 'spring' as const, stiffness: 300, damping: 30 };
